<template>
  <div>
    <e-chart v-if="hasData" :options="chartOptions" autoresize></e-chart>
    <div v-else-if="loaded">
      <span>{{ $t("No Alerts") }}</span>
      <b-icon icon="hand-thumbs-up" variant="success" font-scale="1" style="margin-left: 4px"></b-icon>
    </div>
    <SpinnerCmpt v-else></SpinnerCmpt>
  </div>
</template>

<script>
import SpinnerCmpt from '@/xvisor/components/SpinnerCmpt.vue';
import colorPalette from '@/xvisor/constants/colorPalette';
import colorPaletteShade from '@/xvisor/constants/colorPaletteShade';
import themeStyle from '@/xvisor/utilities/themeStyle';

const labelsMap = new Map([
  ['Unauthorized DNS Connection', 'DNS'],
  ['Unauthorized Domain Connection', 'URLs'],
  ['Unauthorized Ssid Connection', 'SSID'],
]);

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  components: {
    SpinnerCmpt,
  },
  data() {
    return {
      series: [],
      loaded: false,
    };
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    timeRange() {
      this.httpGet();
    },
  },
  computed: {
    hasData() {
      return this.loaded && this.series && this.series.length > 0;
    },
    toggleColor() {
      return themeStyle.styleToggle(colorPalette.black, colorPalette.white);
    },
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
    formatData() {
      return this.series.map((item) => {
        const {
          name,
          count,
        } = item;
        const labelName = labelsMap.get(name) || name;
        return { value: count, name: labelName };
      });
    },
    chartOptions() {
      return {
        title: {
          show: false,
        },
        legend: {
          bottom: 4,
          textStyle: {
            color: this.toggleColor,
          },
          formatter: (name) => {
            const dataItem = this.formatData.find((item) => item.name === name);
            return dataItem ? `${name}: ${dataItem.value}` : name;
          },
        },
        tooltip: {
          trigger: 'item',
        },
        color: [
          colorPaletteShade.teal4,
          colorPaletteShade.orange5,
          colorPaletteShade.indigo4,
          colorPaletteShade.purple4,
          colorPaletteShade.green4,
        ],
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            radius: '67%',
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: this.formatData,
            top: '-15%',
          },
        ],
      };
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.url, this.httpParams)
        .then((response) => {
          this.series = response.data;
        })
        .finally(() => { this.loaded = true; });
    },
  },
};
</script>
